import client from '@/api/client'

export async function fetchProfile () {
  const response = await client.get('/profile')
  return response.data
}
